module.exports = __webpack_public_path__ + "static/custom-events4-21f73dc9262f3bb6c47d4c8729f259de.png";